import React, { useEffect, useState } from 'react';
import type { EventEmitter } from '@meitu/saas-editor-core/es/framework';
import { FetchLoading } from '@/components/fetch-loading';

type StageLoadingItemProps = {
    index: number;
    theme: string;
};
const StageLoadingItem: React.FC<StageLoadingItemProps> = React.memo(({ index, theme }) => {
    return (
        <div className="c-navigation-collapse__item">
            <div className="c-navigation-collapse__item-preview" style={{ height: 95 }}>
                <div
                    className="c-navigation-collapse__item-content"
                    style={{
                        width: 246,
                        height: 137,
                        borderRadius: 4,
                        borderWidth: 1,
                        transform: `translate(-50%, -50%)`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <FetchLoading width={75} theme={theme} />
                </div>
            </div>
        </div>
    );
});

const LOADING_AI_PPT_EVENT = 'LOADING_AI_PPT_EVENT';
type StageLoadingProps = {
    events: EventEmitter;
    theme: string;
};
export const StageLoading = React.memo(({ events, theme }: StageLoadingProps) => {
    const [pages, setPages] = useState<number[]>([]);

    useEffect(() => {
        const onLoadingAIPPT = (nowPage: number, allPage: number) => {
            if (!allPage) {
                setPages([]);
                return;
            }
            if (nowPage > allPage) {
                setPages([]);
                return;
            }
            setPages([nowPage]);
        };
        events.on(LOADING_AI_PPT_EVENT, onLoadingAIPPT);
        return () => {
            events.off(LOADING_AI_PPT_EVENT, onLoadingAIPPT);
        };
    }, []);

    if (!pages.length) return null;

    return (
        <>
            {pages.map((item, index) => {
                return <StageLoadingItem key={index} index={item} theme={theme} />;
            })}
        </>
    );
});
